
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { FontIcon } from "office-ui-fabric-react";

import { INPUT_TYPE_DRAW, INPUT_TYPE_FILE, INPUT_TYPE_PROJECT } from '../../reducers/project';

const classNames = mergeStyleSets({
    label: {
        borderBottom: '1px solid black'
    },

    labelBox: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'end'
    },

    ico: {
        marginRight: '1em'
    },

    container: {
        height: '40px !important'
    }
});

const SelectInputTypeDisabled = ({
    inputType,
    readedFromFile
}) => {

    const getInputTypeText = () => {
        switch (inputType) {
            case INPUT_TYPE_FILE:
                return (readedFromFile)
                    ? 'Načtené ze zadaného souboru'
                    : 'Načíst ze zadaného souboru';
            case INPUT_TYPE_DRAW:
                return 'Nakreslit úseky mezí v mapě';
            case INPUT_TYPE_PROJECT:
                return 'Načtené z uloženého projektu';
            default:
                return '';
        }
    }

    return (
        <Stack vertical className={classNames.container}>
            <Stack.Item>
                <h3 className={classNames.label}>Způsob zadání úseků mezí</h3>
            </Stack.Item>
            <Stack.Item className={classNames.labelBox}>
                <FontIcon className={classNames.ico} iconName="GripperDotsVertical"></FontIcon>
                <div>{getInputTypeText()}</div>
            </Stack.Item>
        </Stack>
    );
}

export default SelectInputTypeDisabled;
